import { Center, Group, SegmentedControl } from "@mantine/core";
import { IconList, IconMessage, IconUserPlus } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";

const LinkedinTopMenu = () => {
  const lang = useLanguage((s) => s.language);
  const location = useLocation();
  const locations = location.pathname.split("/").filter(Boolean);
  const actualLocation = locations[locations.length - 1];

  const items = [
    {
      label: (
        <Center component={Group}>
          <IconList size={18} />

          <span>Tous</span>
        </Center>
      ),
      value: "linkedin",
    },
    {
      label: (
        <Center component={Group}>
          <IconUserPlus size={18} />

          <span>Invitations</span>
        </Center>
      ),
      value: "linkedin-invitation",
    },
    {
      label: (
        <Center component={Group}>
          <IconMessage size={18} />

          <span>Messages</span>
        </Center>
      ),
      value: "linkedin-message",
    },
  ];

  const navigate = useNavigate();
  return (
    <SegmentedControl
      mx={"auto"}
      size="sm"
      w={600}
      data={items}
      value={items.find((x) => x.value === actualLocation)?.value || "linkedin"}
      onChange={(v) => {
        navigate("/models/" + v);
      }}
    />
  );
};

export default LinkedinTopMenu;
